import HeaderAndCTA from '@/components/HighlightImageTextStacked/HeaderAndCTA/HeaderAndCTA';
import useSharedStyles from '@/components/HighlightImageTextStacked/SharedStackedStyles.styles';
import SingleStack from '@/components/HighlightImageTextStacked/SingleStack/SingleStack';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import type { ButtonContent } from '@/components/OldButton/OldButton';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import { type Contentful, ContentStyle } from '@/contentful/contentful-exports';
import type { PlaylistVideoCardCf } from '@/types';

import { Playlist } from './Playlist/Playlist';

type VideoStackedFields = {
  name: string;
  videos?: string[];
  subhead?: string;
  body?: string;
  cta?: ButtonContent;
};

export interface VideoTextStacked extends Contentful {
  fields: VideoStackedFields;
}

export interface HighlightVideoInlineContent extends Contentful {
  fields: {
    id: string;
    style?: ContentStyle;
    eyebrow?: string;
    headline?: string;
    subheading?: string;
    videoTextStacked?: VideoTextStacked;
    playlistVideos?: PlaylistVideoCardCf[];
  };
}

type HighlightVideoInlineProps = {
  content: HighlightVideoInlineContent;
};

export default function HighlightVideoInline({
  content: {
    fields: {
      id,
      style = ContentStyle.OnDark,
      eyebrow,
      headline,
      subheading,
      videoTextStacked,
      playlistVideos,
    },
  },
}: HighlightVideoInlineProps) {
  const isOnDark = style === ContentStyle.OnDark;
  const { classes: sharedClassees } = useSharedStyles({ isOnDark });
  const hasPlaylist = playlistVideos && playlistVideos.length > 0;

  return (
    <SpacingContainer
      id={`highlight-stack ${id}`}
      className={sharedClassees.container}
    >
      <HeaderAndCTA
        isOnDark={isOnDark}
        eyebrow={eyebrow}
        subheading={subheading}
        headline={headline}
        fullWidth={hasPlaylist}
      />
      <GridContainer fixed>
        {videoTextStacked && !hasPlaylist && (
          <SingleStack content={videoTextStacked} isOnDark={isOnDark} />
        )}
        {hasPlaylist && (
          <Playlist videos={playlistVideos} isOnDark={isOnDark} />
        )}
      </GridContainer>
    </SpacingContainer>
  );
}
